// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1N4Nr","additionalInfo":"AgreementModal_additionalInfo__18wBZ"};